<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="modalController.dismiss()">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>Synced Documents</ion-title>
        <ion-buttons slot="end">
            <ion-button (click)="showFilters()">
                <ion-icon slot="icon-only" name="filter-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-searchbar placeholder="Search Documents" debounce="300" [(ngModel)]="queryText"></ion-searchbar>
    <ion-refresher slot="fixed" (ionRefresh)="refreshDocs($event)">
        <ion-refresher-content
                pullingIcon="arrow-dropdown"
                pullingText="Pull to refresh"
                refreshingSpinner="circles"
                refreshingText="Fetching Documents...">
        </ion-refresher-content>
    </ion-refresher>
    <ion-list>
        <ion-item *ngFor="let doc of queuedDocs | filterDocs: queryText"  class="ion-activatable">
        
            <!--[color]="getSyncStatusColor(doc)"-->
                <ion-icon [name]="setIconDoc(doc.documentBean.documentType)"
                          (click)="openModalDocument(doc.documentBean)"
                          [style]="getSyncStatusColor(doc)"></ion-icon>
                
                <ion-label class="ion-padding-horizontal" color="none" (click)="openModalDocument(doc.documentBean)"
                           *ngIf="doc.documentBean.documentType !==  documentTypes.SERVICEJOB && doc.documentBean.documentType !==  documentTypes.CUSTOMERREPAIR">
                    <p>{{ doc.documentBean.customer.name }} <span *ngIf="doc.documentBeandocumentType === 501"> Purchase Order</span></p>
                    <p *ngIf="doc.documentBean.documentNumber > 0"><span *ngIf="doc.documentBean.documentType === documentTypes.SIGNDOCUMENT">
                        {{doc.documentBean.originalDocumentType === 1 ? 'Delivery - ' : doc.documentBean.originalDocumentType === 7 ? 'Collection - ' : doc.documentBean.originalDocumentType === 2 ? 'Return - ' : 'Sign Document - ' }}
                        </span>{{doc.documentBean.documentNumber}}</p>
                </ion-label>


                <ion-label class="ion-padding-start" color="none" (click)="openModalDocument(doc.documentBean)"
                           *ngIf="doc.documentBean.documentType === documentTypes.SERVICEJOB || doc.documentBean.documentType === documentTypes.CUSTOMERREPAIR">
                    <h3 *ngIf="doc.documentBean.serviceJob.jobNumber !== 0">Job
                        Number: {{doc.documentBean.serviceJob.jobNumber}}
                        - {{doc.documentBean.serviceJob.scheduledDate | date:'dd/MM/yyyy'}}</h3>
                    <h3>{{jobTypeDescription(doc.documentBean.serviceJob.jobTypeId)}}</h3>
                    <h4 *ngIf="doc.documentBean.serviceJob.servicedItem.pdesc" style="color: #1aacc3">
                        {{doc.documentBean.serviceJob.servicedItem.pdesc}}
                        -{{doc.documentBean.serviceJob.servicedItem.reg}}</h4>
                    <h4 *ngIf="doc.documentBean.serviceJob.servicedItem.serial" style="color: #1aacc3">
                        Serial - {{doc.documentBean.serviceJob.servicedItem.serial}}</h4>
                    <h4 *ngIf="doc.documentBean.serviceJob.servicedItem.plu" style="color: #1aacc3">
                        {{doc.documentBean.serviceJob.servicedItem.plu}}</h4>
                    <h4 style="color: #1aacc3">{{doc.documentBean.serviceJob.servicedItem.description}}</h4>
                    <h4 *ngIf="doc.documentBean.serviceJob.cust"
                        style="color: #1aacc3">{{doc.documentBean.serviceJob.cust.name}}</h4>
                    <p><strong>{{doc.documentBean.comment}}</strong></p>

                    <p *ngIf="doc.documentBean.serviceJob.binLocation.locationTag"> Bin Location -
                        <span style="color: cornflowerblue;"> {{doc.documentBean.serviceJob.binLocation.locationTag}} </span>
                    </p>

                    <p>{{doc.documentBean.serviceJob.completedJob ? 'Completed' : 'Not Completed'}}
                        <span *ngIf="doc.documentBean.serviceJob.engineer">- {{doc.documentBean.serviceJob.engineer.name}}
                        </span>
                    </p>
                    
                </ion-label>
               
            
        </ion-item>
    </ion-list>

</ion-content>
